const resource = 'visits'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  create(params) {
    return $axios.$post(`/${resource}`, params)
  },
  delete(visits) {
    return $axios.$delete(`/${resource}`, { data: { visits } })
  },

  getServiceName: name => 'visitService',
})
